module.exports = __webpack_public_path__ + "img/1.08185ae5.jpg";